import { forwardRef, useImperativeHandle, useState } from "react";
import { LuX } from "react-icons/lu";

interface ModalLayoutProps {
  onClose: () => void;
  children: React.ReactNode;
  className?: string;
}

export interface ModalLayoutRef {
  triggerClose: () => void;
}

export const ModalLayout = forwardRef<ModalLayoutRef, ModalLayoutProps>(
  ({ onClose, children, className = "" }, ref) => {
    const [isClosing, setIsClosing] = useState(false);

    useImperativeHandle(ref, () => ({
      triggerClose: () => {
        if (!isClosing) {
          setIsClosing(true);
          setTimeout(() => {
            onClose();
          }, 300);
        }
      },
    }));

    const handleClose = () => {
      if (!isClosing) {
        setIsClosing(true);
        setTimeout(() => {
          onClose();
        }, 300);
      }
    };

    return (
      <div
        className={`${
          isClosing ? "animate-fade-out" : "animate-fade-in"
        } absolute inset-0 p-8
        flex items-center justify-center
        bg-black/25 backdrop-blur-sm
        transition-opacity duration-300 z-50`}
        onClick={handleClose}
      >
        <div
          className={`max-h-[600px] w-fit 
            rounded-lg relative 
          bg-light-surface-primary dark:bg-[#2B2E32]
          shadow-[0_4px_2.6px_0_rgba(0,0,0,0.46),0_3px_14.2px_0_rgba(0,0,0,0.3)]
          transform transition-all duration-300 ease-in-out
          overflow-hidden ${className}`}
          onClick={(e) => e.stopPropagation()}
        >
          <button
            onClick={handleClose}
            className="absolute top-3 right-3 z-10
            text-light-placeholder dark:text-dark-placeholder
            hover:brightness-150 transition-all duration-300"
          >
            <LuX size={24} />
          </button>

          <div className="w-full h-full overflow-y-auto">{children}</div>
        </div>
      </div>
    );
  }
);
